/* RAVIN Balaleen readiness: never show invisible outline text if font unavailable. */
(()=>{
 const activate=async()=>{
  if(!document.fonts||!document.fonts.load)return;
  try{
   const loaded=await document.fonts.load('400 80px "Balaleen Line"','اختار عالمك');
   if(loaded.some(face=>face.status==='loaded'&&face.family.replace(/["']/g,'').trim()==='Balaleen Line')){
     document.documentElement.classList.add('rv-balaleen-ready');
   }
  }catch(e){/* The licensed webfont has not yet been uploaded: readable fallback stays. */}
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',activate,{once:true});
 else activate();
 document.addEventListener('shopify:section:load',activate);
})();
